import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from 'src/app/vme-common.module';
import { VMEComponentsModule } from 'src/app/vme-components.module';
import { VmeDirectivesModule } from 'src/app/vme-directives.module';
import { VmePipesModule } from 'src/app/vme-pipes.module';
import { ToastModule } from 'primeng';
import { SupplierJobsInboxModule } from './supplier-jobs-inbox.module';
import { PlannedRoutesComponent } from './planned-routes.component';
import { PlannedRoutesTabComponent } from './planned-routes-tab.component';
import { PlannedRouteItemComponent } from './planned-route-item.component';
import { AlgoTravelPreferencesModule } from '../../../components/algo-travel-preferences/algo-travel-preferences.module';
import { RouteItineraryComponent } from '../../../components/route-recommendations/route-itinerary/route-itinerary.component';
import { RouteItineraryConfirmStartDateComponent } from '../../../components/route-recommendations/route-itinerary/popups/route-itinerary-confirm-start-date/route-itinerary-confirm-start-date.component';
import { RouteItineraryConfirmationPopupComponent } from '../../../components/route-recommendations/route-itinerary/popups/route-itinerary-confirmation-popup/route-itinerary-confirmation-popup.component';
import { RouteItineraryPopupComponent } from '../../../components/route-recommendations/route-itinerary/popups/route-itinerary-popup/route-itinerary-popup.component';
import { RouteItineraryAlertComponent } from '../../../components/route-recommendations/route-itinerary/components/route-itinerary-alert/route-itinerary-alert.component';
import { RouteDayToggleComponent } from './route-day-toggle.component';
import { GrabBonusBadgeComponent } from '../../../components/route-recommendations/grab-bonus-badge/grab-bonus-badge.component';

const routes: Routes = [{ path: '', component: PlannedRoutesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlannedRoutesRoutingModule {}

@NgModule({
  imports: [
    PlannedRoutesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
    SupplierJobsInboxModule,
    AlgoTravelPreferencesModule,
    RouteItineraryComponent,
    RouteItineraryConfirmStartDateComponent,
    RouteItineraryConfirmationPopupComponent,
    RouteItineraryPopupComponent,
    RouteItineraryAlertComponent,
    RouteDayToggleComponent,
    GrabBonusBadgeComponent,
  ],
  declarations: [PlannedRoutesComponent, PlannedRoutesTabComponent, PlannedRouteItemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlannedRoutesModule {}
